import { HomePageContainer } from "./HomeStyles";
import Footer from "../../components/footer/Footer";
import Newsletter from "../../components/newsletter/Newsletter";
import Imagewheel from "../../components/imagewheel/Imagewheel";
import Sector from "../../components/sector/Sector";
import Walkthrough from "../../components/walkthrough/Walkthrough";
import VacancyFinder from "../../components/vacancyFinder/VacancyFinder";
import About from "../../components/about/About";
import AboutExtended from "../../components/aboutExtended/AboutExtended";

function Home() {
  const images = ["/assets/1.jpg", "/assets/2.jpg", "/assets/3.jpg"];

  return (
    <HomePageContainer>
      {/* Home: Imagewheel with extra text card */}
      <Imagewheel images={images} isHome={true} />

      {/* Home: Text & About Cards */}
      <About />

      {/* Home: Vacancy Finder */}
      <VacancyFinder />

      {/* Home: About Section */}
      <AboutExtended />

      {/* Home: Hoe Smart werkt */}
      <Walkthrough page="home" />

      {/* Home: Sectoren */}
      <Sector />

      {/* Home: Newsletter */}
      <Newsletter />

      {/* Home: Footer */}
      <Footer />
    </HomePageContainer>
  );
}

export default Home;
